import { getPerformance, trace } from "firebase/performance";
import { getApps } from "firebase/app";


export interface notification {
    id : number,
    type : string,
    actionId : number,
    createdAt : string,
    isRead : boolean,
    announcement : {
      pictures : {
        fileName : string
      }[]
    }
    fromUser : {
        id : number,
        fullName : string,
        picture : string
    }
}

export type notificationList = notification[];

interface userNotification {
  notifList: notificationList;
}
const dash = useDashboardStore();

const state = (): userNotification => ({
    notifList: [],
});

const getters = {
  getUserNotification: (state: userNotification) => {
   return state.notifList
  },
  getIsNotRead: (state: userNotification) => {
    let i = 0
      state.notifList.map(item => {if (item.isRead == false) i++ } )

        return i
  },
};

export const useNotifyStore = defineStore("NotifyStore", {
  state,
  getters,
  actions: {


   async  fetchNotification() {
    const runTimeConfig = useRuntimeConfig();
    const cookie = useCookie("userToken");
    let fetchTrace;
    if (getApps().length > 0) {
      const performance = getPerformance();
      fetchTrace = trace(performance, 'fetchNotification');
      fetchTrace.start();
    }

    try {
      const response = await $fetch<notificationList>(
        "/users/my-notifications",
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + cookie.value,
          },

          baseURL: runTimeConfig.public.baseUrl,
        }
      );

      this.notifList = response


    } catch (error) {
      // console.log(error);
      throw new Error(String(error))
    } finally {
      if (fetchTrace) {
        fetchTrace.stop();
      }
    }
   },
   async  readNotif(id : number) {
    const runTimeConfig = useRuntimeConfig();
    const cookie = useCookie("userToken");

    try {
      const response = await $fetch<boolean>(
        "/notifications/read",
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + cookie.value,
          },
          body:{
            notificationId : id
          },

          baseURL: runTimeConfig.public.baseUrl,
        }
      );
      // Update the store after marking the notification as read

      if (response) {
        const notificationIndex = this.notifList.findIndex((notif) => notif.id === id);
        if (notificationIndex !== -1) {
          this.notifList[notificationIndex].isRead = true;
          dash.userProfil.newNotificationsNumber >0 && ( dash.userProfil.newNotificationsNumber -= 1);
        }
      }
            
       
      return response


    } catch (error) {
      // console.log(error);
throw new Error(String(error))
    }
   }
  },
});

